import { render, staticRenderFns } from "./AddDocumentDialog.vue?vue&type=template&id=d5bc29f6"
import script from "./AddDocumentDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddDocumentDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./AddDocumentDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports